<div class="admin-state" data-testid="admin-state">
  <p class="admin-state__heading">{{ headingText }}</p>
  <p class="admin-state__message">{{ messageText }}</p>
  @if (actionLabel) {
    <button
      mat-stroked-button
      type="button"
      class="admin-state__action"
      data-testid="admin-state-action"
      (click)="onAction()"
    >
      {{ actionLabel }}
    </button>
  }
</div>
